<template>
  <Modal 
    :id="'cmp-catalog-licence-add-account'" 
    @cancelled="onCancel"
  >
    <template slot="header">{{$t('Export')}} {{  $dft.snakeCaseToWords('licence_lines')}} </template>
    <template slot="body">
      <div class="form-group">
        <TextField
          class="m1"
          type="date"
          :id="'invoice_date_start'"
          v-bind="textFieldConfig"
        
          :value="payloadObject.invoice_date_start"
          :placeholder="$t('invoice_date_start')"
          @valuechanged="onTextFieldValueChange"
        
        />
        <TextField
          class="m1"
          type="date"
          :id="'invoice_date_end'"
          v-bind="textFieldConfig"
        
          :value="payloadObject.invoice_date_end"
          :placeholder="$t('invoice_date_end')"
          @valuechanged="onTextFieldValueChange"
        
        />
        <TextField
          class="m1"
          type="date"
          :id="'payment_date_start'"
          v-bind="textFieldConfig"
        
          :value="payloadObject.payment_date_start"
          :placeholder="$t('payment_date_start')"
          @valuechanged="onTextFieldValueChange"
        
        />
        <TextField
          class="m1"
          type="date"
          :id="'payment_date_end'"
          v-bind="textFieldConfig"
        
          :value="payloadObject.payment_date_end"
          :placeholder="$t('payment_date_end')"
          @valuechanged="onTextFieldValueChange"
        
        />
        <TextField
          class="m1"
          type="date"
          :id="'line_date_start'"
          v-bind="textFieldConfig"
        
          :value="payloadObject.line_date_start"
          :placeholder="$t('line_date_start')"
          @valuechanged="onTextFieldValueChange"
        
        />
        <TextField
          class="m1"
          type="date"
          :id="'line_date_end'"
          v-bind="textFieldConfig"
        
          :value="payloadObject.line_date_end"
          :placeholder="$t('line_date_end')"
          @valuechanged="onTextFieldValueChange"
        
        />
        <TextField
          class="m1"
         
          :id="'year'"
          v-bind="textFieldConfig"
        
          :value="payloadObject.year"
          :placeholder="$t('year')"
          @valuechanged="onTextFieldValueChange"
        
        />

      </div>
    </template>
    <template slot="options">
      
      <button 
        class="dt-button s6" 
        @click.stop="onCancel"
      >Cancel</button>
      <button
        class="dt-button v1 with-ico"
       
        @click.stop="onExport"
      >
        {{$t('ok')}}
      </button>
    </template>
  </Modal>
</template>

<script>

import Modal from '@dtplugins/modal/modal';
import { licenceAccountsService } from '../../services/licence-accounts.service';
import DTCheckbox from "../../../../plugins/checkbox/checkbox";
import {
  createTV,
  tv,
} from "../../../../models/text-value.model";
import { licenceService } from '../../services/licence.service';
import FileDownload from "js-file-download";
import { format } from "date-fns";
export default {
  components: {
    Modal,
    DTCheckbox,

  },
  props: {
    
  },
  data: function() {
    return {
     textFieldConfig: {
        height: 42,
        showEditIconOnHover: false,
        box: true,
        // showValidationIcons: true,
        // immediateValidation: true,
        //format(new Date().setDate(new Date().getDate() + 7), "YYYY-MM-DD")
      },
      payloadObject:{
          year:new Date().getFullYear(),
          invoice_date_start:'',
          invoice_date_end:'',
          payment_date_start:'',
          payment_date_end:'',
          line_date_start:'',
          line_date_end:'',
      },
      validationResult: {},
    };
  },
  mounted:async function() {
    // const resData= await licenceService.exportLicenceLinesModal();
    // console.log("resData",resData);
    // this.territoryList=resData.data.territories;
    // this.trackList=resData.data.tracks

  },
  computed: {
    isFormValid: function() {
      return Object.values(this.validationResult).every(e => e.valid);
    },
  },
  methods: {
    onValidation: function(name, value) {
      this.$set(this.validationResult, name, value);
      console.log(this.validationResult);
    },
    onTextFieldValueChange:function(key, value){
      console.log("NAME",key,value)
      this.payloadObject[key]=value
    },
    onCancel: function() {
      this.$emit("cancelled", true);
    },
    onExport: function() {
      const fileBlob =licenceService.exportLicenceLines({...this.payloadObject}).then(res=>{
        console.log(res)
        FileDownload(res.data,'Licence_lines.xlsx');
      });

    }
    //MARK: Methods
  }
};


</script>

<style lang="scss">
.cmp-catalog-licence-add-account {
}
</style>